const images = {
  logo: require("../assets/images/gotikLogo.png"),
  avt: require("../assets/images/avatar.png"),
  logKey: require("../assets/images/Reset password-pana.svg"),
  dashboard: require("../assets/images/Revenue-cuate.svg"),
  notFound: require("../assets/images/Oops 404 Error with a broken robot-cuate.svg"),
};

export default images;
